import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { JVDropdown } from "../../../../shared/JVDropdown";
import { JVInput } from "../../../../shared/JVInput";
import { Fetch } from "../../../../shared/Fetch";
import { useEffect, useState } from "react";
import { ITrainer } from "./Table";

interface IProps {
    open: boolean,
    singleData: ITrainer,
    hideDialog: () => void,
    toast: any,
    reloadTable: () => void,
}

interface ITrainnerUsers {
    approve_Status?: boolean | null,
    rejection_Comment?: string | null,
}

const schema = yup.object({
    approve_Status: yup.boolean().required("Status is required").typeError("Status is required"),
    rejection_Comment: yup.string().nullable()
});

export const ApproveSelection = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [shwComment, setShwComment] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<ITrainnerUsers>({
        resolver: yupResolver(schema),
        defaultValues: { approve_Status: null, rejection_Comment: null },
        shouldFocusError: false
    });

    const onHide = () => {
        setLoading(false);
        setShwComment(false);
        props.reloadTable();
        props.hideDialog();
    }

    const onSubmit = async (data: ITrainnerUsers) => {
        if (data.approve_Status === false && (data.rejection_Comment === null || data.rejection_Comment?.trim() === "")) {
            props.toast.current.show({ severity: 'error', detail: "Write Something in Reason", life: 3000 });
        } else {
            setLoading(true);
            const method = "POST";
            const message = "Update Successfully";

            const newBody: ITrainer = { trainer_ID: props.singleData.trainer_ID, approve_Status: data.approve_Status || false, rejection_Comment: data.rejection_Comment || "" };

            const response = await Fetch("CarnivalTraining/updateTrainerStatusByID", method, newBody, null, props.toast);

            if (response) {
                setLoading(false);
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                onHide();
            } else setLoading(false);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "approve_Status") {
                if (value.approve_Status != null && value.approve_Status === false) {
                    setShwComment(true);
                } else {
                    setShwComment(false);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, shwComment]);

    useEffect(() => {
        if (props.open) {
            reset({ approve_Status: props.singleData.approve_Status, rejection_Comment: props.singleData.rejection_Comment })
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '30vw' }} header="Edit Trainers" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid w-full">
                <JVDropdown column={2} required label="Status" control={control} name="approve_Status" options={[{ name: "-- SELECT --", value: null }, { name: "Accept", value: true }, , { name: "Reject", value: false }]} optionLabel="name" optionValue="value" placeholder="Select Status" error={errors.approve_Status?.message} />
                <JVInput column={2} disabled={!shwComment} required={shwComment} label="Rejection Reason" control={control} name="rejection_Comment" error={errors.rejection_Comment?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading} ></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}